import type { Profile } from "../data/questions";
import type { EmailVariantKey } from "../data/emailVariants";

const KEY_STATE = "quiz_state_v1";
const KEY_VARIANT = "email_variant";

export type Screen = "hero" | "quiz" | "email" | "result";

export interface PersistedState {
  screen: Screen;
  currentQuestion: number;
  answers: number[];
  profile: Profile | null;
  percentage: number | null;
  emailSubmitted?: boolean;
}

const isBrowser = typeof window !== "undefined";

export function loadState(): PersistedState | null {
  if (!isBrowser) return null;
  try {
    const raw = localStorage.getItem(KEY_STATE);
    if (!raw) return null;
    return JSON.parse(raw) as PersistedState;
  } catch {
    return null;
  }
}

export function saveState(state: PersistedState) {
  if (!isBrowser) return;
  try {
    localStorage.setItem(KEY_STATE, JSON.stringify(state));
  } catch {
    /* quota exceeded ou Safari mode privé : on ignore silencieusement */
  }
}

export function clearState() {
  if (!isBrowser) return;
  try {
    localStorage.removeItem(KEY_STATE);
  } catch {
    /* ignore */
  }
}

export function getOrCreateEmailVariant(): EmailVariantKey {
  if (!isBrowser) return "A";
  try {
    const cached = localStorage.getItem(KEY_VARIANT) as EmailVariantKey | null;
    if (cached === "A" || cached === "B") return cached;
    const picked: EmailVariantKey = Math.random() < 0.5 ? "A" : "B";
    localStorage.setItem(KEY_VARIANT, picked);
    return picked;
  } catch {
    return Math.random() < 0.5 ? "A" : "B";
  }
}
